// Types
import {
  SectionFragment,
  ItemFragment,
  PermissionsFragment,
  LinkFragment,
  SizeFragment,
} from '@sketch/gql-types'

export const defaultSectionValues: Partial<SectionFragment> = {
  __typename: 'Section',
  categories: null,
  items: [],
  limit: null,
  links: null,
  permissions: null,
  size: null,
  stretchedContent: null,
  subTitle: null,
  title: null,
  visibility: {
    __typename: 'Visibility',
    hiddenForFF: null,
    hideOnBreakpoint: null,
  },
}

export const defaultItemValues: Partial<ItemFragment> = {
  __typename: 'Item',
  author: null,
  categories: null,
  contentPosition: null,
  featured: null,
  icon: null,
  length: null,
  links: null,
  mobile: null,
  note: null,
  permissions: null,
  size: null,
  source: null,
  url: null,
  content: null,
  image: null,
  video: null,
  backgroundColor: null,
  place: null,
  date: null,
  speakers: [],
}

export const defaultPermissionsValues: Partial<PermissionsFragment> = {
  __typename: 'Permissions',
  audience: null,
  categories: null,
  roles: null,
}

export const defaultLinkValues: Partial<LinkFragment> = {
  __typename: 'Link',
  icon: null,
  text: null,
  variant: null,
}

export const defaultSizeValues: Partial<SizeFragment> = {
  __typename: 'Size',
  lg: null,
  md: null,
  sm: null,
  xl: null,
  xs: null,
}

export const defaultSectionSubtitleValues: Partial<
  SectionFragment['subTitle']
> = {
  __typename: 'SectionSubTitle',
  visibility: {
    __typename: 'Visibility',
    hiddenForFF: null,
    hideOnBreakpoint: null,
  },
}

export const defaultItemMobileValues: Partial<ItemFragment['mobile']> = {
  __typename: 'ItemMobile',
  description: null,
  icon: null,
}

export const defaultResponsiveImageValues: Partial<ItemFragment['image']> = {
  __typename: 'ResponsiveImage',
  alt: null,
  source: {
    __typename: 'ResponsiveSource',
    xs: null,
    sm: null,
    md: null,
    lg: null,
    xl: null,
  },
}

export const defaultSingleImageValues: Partial<ItemFragment['image']> = {
  __typename: 'SingleImage',
  alt: null,
}
